import type React from "react";

/**
 * Serves images resized and converted to WebP through the wsrv.nl image CDN,
 * so the browser downloads only the pixels it actually displays.
 */
export function optimizedImage(url: string, width: number, quality = 72): string {
  return `https://wsrv.nl/?url=${encodeURIComponent(url)}&w=${width}&output=webp&q=${quality}`;
}

export function optimizedSrcSet(url: string, width: number): string {
  return `${optimizedImage(url, width)} 1x, ${optimizedImage(url, width * 2)} 2x`;
}

/** Falls back to the original file if the optimizer is unreachable. */
export function fallbackToOriginal(original: string) {
  return (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    if (img.dataset.fallback) return;
    img.dataset.fallback = "1";
    img.removeAttribute("srcset");
    img.src = original;
  };
}
